import classNames from 'classnames';
import React from 'react';

export function IconButton(props: { iconClass: string; onClick: () => void; text?: string; primary?: undefined | boolean; title?: string }) {
    const classValue = classNames({
        btn: true,
        'btn-xs': true,
        ml5: true,
        'btn-default': !props.primary,
        'btn-primary': props.primary,
    });

    return (
        <button
            title={props.title}
            type="button"
            className={classValue}
            style={{ float: 'right' }}
            onClick={(e) => {
                e.stopPropagation();
                props.onClick();
            }}
        >
            <i className={`fa ${props.iconClass}`}></i>
            {props.text && <span className="fs12 ml5">{props.text}</span>}
        </button>
    );
}
